import React, { SVGProps } from 'react'
const SvgProcessingLoD = (
  props: SVGProps<SVGSVGElement>,
): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    aria-hidden="true"
    {...props}
  >
    <g fill="#FFF" fillRule="nonzero">
      <path d="M12 .5c.385 0 .767.019 1.147.057l-.296 2.985A8.62 8.62 0 0 0 12 3.5c-.002-.005-.004-.002-.007 0a8.67 8.67 0 0 0-.368.008l-.13-2.997c.165-.007.33-.01.496-.011L12 .51V.5ZM15.403 1.012l-.887 2.866a8.428 8.428 0 0 0-.823-.21l.594-2.94c.377.076.75.17 1.116.284ZM17.542 1.922l-1.447 2.627a8.458 8.458 0 0 0-.764-.372l1.177-2.76c.353.151.698.32 1.034.505ZM19.491 3.275 17.536 5.55a8.543 8.543 0 0 0-.672-.522l1.72-2.458c.314.22.617.455.907.705ZM21.047 4.9l-2.359 1.853a8.548 8.548 0 0 0-.345-.411l-.214-.231 2.163-2.08.043.046c.25.264.488.538.712.823ZM22.28 6.841 19.6 8.188a8.486 8.486 0 0 0-.42-.739l2.533-1.609c.205.324.395.658.567 1.001ZM23.108 9.013l-2.898.777a8.422 8.422 0 0 0-.26-.807l2.804-1.066c.136.359.254.724.354 1.096ZM23.482 11.355l-2.995.166a8.534 8.534 0 0 0-.09-.846l2.965-.463c.059.377.099.759.12 1.143Z" />
      <path
        d="m23.39 13.593-2.971-.412c.039-.28.064-.563.075-.848l2.997.115c-.014.385-.048.767-.1 1.145Z"
        opacity={0.01}
      />
      <path
        d="m22.846 15.832-2.83-1c.095-.266.176-.537.243-.813l2.915.71c-.091.374-.2.742-.328 1.103Z"
        opacity={0.05}
      />
      <path
        d="m21.848 17.941-2.567-1.552c.146-.242.28-.492.402-.748l2.71 1.287c-.164.347-.346.685-.545 1.013Z"
        opacity={0.1}
      />
      <path
        d="m20.472 19.777-2.21-2.03a8.649 8.649 0 0 0 .548-.66l2.402 1.798a11.557 11.557 0 0 1-.74.892Z"
        opacity={0.15}
      />
      <path
        d="m18.758 21.306-1.764-2.427c.229-.166.45-.345.662-.534l1.997 2.24c-.286.254-.585.495-.895.72Z"
        opacity={0.2}
      />
      <path
        d="m16.76 22.472-1.244-2.73c.258-.118.51-.248.755-.391l1.51 2.592c-.331.193-.672.37-1.022.529Z"
        opacity={0.25}
      />
      <path
        d="m14.525 23.222-.656-2.928c.276-.062.55-.138.818-.227l.947 2.847c-.364.12-.734.223-1.11.308Z"
        opacity={0.3}
      />
      <path
        d="m12.274 23.497-.07-3a8.58 8.58 0 0 0 .849-.061l.367 2.977a11.58 11.58 0 0 1-1.146.084Z"
        opacity={0.35}
      />
      <path
        d="m9.959 23.32.53-2.954c.277.05.558.086.842.108l-.232 2.991c-.383-.03-.764-.078-1.14-.146Z"
        opacity={0.4}
      />
      <path
        d="m7.74 22.684 1.111-2.786c.263.105.53.197.803.275l-.826 2.884c-.37-.106-.733-.23-1.089-.373Z"
        opacity={0.45}
      />
      <path
        d="m5.666 21.6 1.654-2.503c.236.156.48.3.731.432l-1.396 2.656c-.34-.179-.67-.374-.99-.586Z"
        opacity={0.5}
      />
      <path
        d="m3.898 20.161 2.113-2.129c.202.2.413.39.633.569l-1.892 2.328a11.559 11.559 0 0 1-.854-.768Z"
        opacity={0.55}
      />
      <path
        d="m2.422 18.367 2.497-1.663c.157.236.326.464.506.683l-2.32 1.903a11.536 11.536 0 0 1-.683-.923Z"
        opacity={0.65}
      />
      <path
        d="m1.343 16.329 2.78-1.13c.106.263.226.52.358.77L1.83 17.372c-.18-.34-.342-.687-.487-1.043Z"
        opacity={0.7}
      />
      <path
        d="m.689 14.084 2.95-.54c.052.279.117.555.195.826l-2.881.835a11.434 11.434 0 0 1-.264-1.12Z"
        opacity={0.75}
      />
      <path
        d="m.502 11.797 3 .052-.002.162c0 .235.01.468.03.7l-2.99.248a11.598 11.598 0 0 1-.035-.63L.5 11.882v-.084Z"
        opacity={0.8}
      />
      <path
        d="m.77 9.516 2.929.645a8.47 8.47 0 0 0-.14.838l-2.98-.348c.044-.383.108-.761.19-1.135Z"
        opacity={0.85}
      />
      <path
        d="m1.493 7.32 2.74 1.221a8.43 8.43 0 0 0-.307.792l-2.848-.94c.12-.365.259-.723.415-1.074Z"
        opacity={0.9}
      />
      <path
        d="m2.665 5.283 2.434 1.754c-.166.23-.32.468-.462.713L2.04 6.248c.192-.332.4-.654.625-.965Z"
        opacity={0.95}
      />
      <path d="m4.177 3.571 2.04 2.199-.226.219a8.561 8.561 0 0 0-.374.397L3.366 4.404a11.574 11.574 0 0 1 .81-.833ZM6.007 2.184l1.565 2.559a8.521 8.521 0 0 0-.702.48L5.057 2.831c.306-.232.622-.448.95-.648ZM8.093 1.181l1.019 2.822a8.438 8.438 0 0 0-.783.328L7.03 1.626c.346-.166.7-.314 1.062-.445ZM10.38.613l.419 2.971c-.281.04-.56.093-.834.16L9.25.832C9.62.74 9.998.667 10.38.613Z" />
    </g>
  </svg>
)
export default SvgProcessingLoD
